import React from 'react';
// import shijian from '../img/shijian.png'
import icon2 from '../img/icon2.png'
import icon21 from '../img/icon21.png'
import AppApi from '../utils/bridge.js'
import Nodata from './Nodata';
import ShareLayer from './ShareLayer';
import ReactDOM, { createPortal } from 'react-dom';
import icon22 from '../img/icon22.png'
import icon23 from '../img/icon23.png'
class NewsList extends React.Component {
    constructor(props) {
        super(props)
        console.log(props)
        // let toggleNewsList = props.list.map(item => {
        //     item.toggle = false
        // })

        // props.list.map(item => {
        //     item.toggle = false
        // })

        this.state = {
            isShowLayer: false,
            shareNews: '',
            list:props.list
        }
    }
    componentDidMount() {
        console.log(this.props.list)
    }
    componentWillReceiveProps(props) {
        console.log(props)
        props.list.map(item => {
                item.remarks.map(item2 => {
                    item2.toggle = false
                })
         })
         console.log('-------')
         console.log(props)
         console.log('-------')
        this.setState({
            list:props.list
        })
    }
    render() {

        const openLink = (url) => {
            console.log(url)
            AppApi.open_link({
                url: url,
                show_title_bar: true
            })
        }
        const toggleLayer = (a, b) => {
            console.log(1)
            this.setState({
                isShowLayer: a
            })
            this.setState({
                shareNews: b
            })
            console.log(this.state.isShowLayer)
        }

        const handleChage = (res) => {
            this.setState({
                isShowLayer: res
            })
        }

        const change_toggle = (a,listIndex,commetnIndex) => {
            console.log(a)
            let list = this.state.list
            list[listIndex].remarks[commetnIndex].toggle = !a.toggle
            this.setState({list})
        }

        const CommentText = (props) => {
            console.log(props)
            if(props.txt.length > 55 && !props.toggle) {
                return (
                    props.txt.slice(0,55) + '...'
                )
            }else if (props.txt.length > 55 && props.toggle) {
                return (
                    props.txt
                )
            }else if (props.txt.length <55) {
                return (
                    props.txt
                )
            }

        }

        const ShowAllCommnts = (props) => {
            return (
                !props.item.toggle ? <div className='u-comment-all' onClick={()=> {change_toggle(props.item,props.listIndex,props.commetnIndex)}}>
                查看详情 <img src={icon23} className='u-icon23' />
            </div> : <div className='u-comment-all' onClick={()=> {change_toggle(props.item,props.listIndex,props.commetnIndex)}}>
                收起 <img src={icon23} className='u-icon23 u-roate' />
            </div>
            )
        }





        return (
            <div className='g-news'>
                {
                    this.state.list.length == 0 ?
                        <Nodata />
                        :
                        <ul>
                            {
                                this.state.list.map((item, index) => {
                                    return (
                                        <li key={item.id}>
                                            <div className='m-title-box'>


                                                <div className='u-news-info'>
                                                    <div>
                                                        <span>{item.event_time_str == '' ? '--:--' : item.event_time_str}</span>
                                                        <span>{item.country}</span>
                                                    </div>
                                                    {/* <img src={require('../img/' + item.event_type_name + '.png')} className='u-news-icon' /> */}
                                                    <img src={icon21} className='u-icon21' onClick={() => { toggleLayer(true, item) }} />
                                                </div>
                                                <p className='u-news-title'>
                                                    {item.title}
                                                </p>
                                            </div>
                                            {
                                                item.remarks.length > 0 ?

                                                    item.remarks.map( (a,bIndex) => {
                                                        return (
                                                            <div className='m-news-comment' key={a.id}>
                                                                <img src={icon22} />
                                                                {/* {a.desc} */}
                                                               <CommentText txt={a.desc} toggle={a.toggle}/>
                                                                

                                                                {
                                                                    // !a.toggle ? <div className='u-comment-all' onClick={()=> {change_toggle(a,index,bIndex)}}>
                                                                    //     查看详情 <img src={icon23} className='u-icon23' />
                                                                    // </div> : ''
                                                                    a.desc.length > 55 ?
                                                                    <ShowAllCommnts item={a} listIndex={index} commetnIndex={bIndex}/>:''
                                                                }



                                                            </div>
                                                        )
                                                    })
                                                    : ''

                                            }

                                            {/* {
                                                item.articles.length > 0 ?
                                                    <div className='u-desc'>
                                                        <img src={icon2} className='u-icon2' />
                                                        <div className='u-aticles'>
                                                            {
                                                                item.articles?.map((item2, index2) => {
                                                                    return (
                                                                        <a href='javascript:void(0)' key={item2.url} onClick={() => { openLink(item2.url) }}>
                                                                            <i className='u-doit'></i> {item2.title}
                                                                        </a>
                                                                    )
                                                                })
                                                            }
                                                        </div>


                                                    </div>
                                                    : ''
                                            } */}




                                        </li>
                                    )
                                })
                            }

                        </ul>
                }

                {createPortal(
                    this.state.isShowLayer ? <ShareLayer sendFn={handleChage} news={this.state.shareNews} /> : '', document.getElementById('root')
                )}

            </div>
        )
    }

}

export default NewsList